import { render, staticRenderFns } from "./BirthdaySelector.vue?vue&type=template&id=d645de74&scoped=true&"
import script from "./BirthdaySelector.vue?vue&type=script&lang=babel&"
export * from "./BirthdaySelector.vue?vue&type=script&lang=babel&"
import style0 from "./BirthdaySelector.vue?vue&type=style&index=0&id=d645de74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d645de74",
  null
  
)

export default component.exports